<app-breadcrumb [title]="title"></app-breadcrumb>

<div class="container-fluid my-5">
  <div class="row">
    <div class="col">
      <app-loader [show]="skeleton"></app-loader>
      <div [class.d-none]="skeleton">
        <div class="alert alert-info">
          <span class="fw-bold">Note:</span>
          <ul>
            <li>Please furnish complete service details (place, post, tenure and reason of
              posting) starting from the Date of joining in NVS.</li>
            <li>Maximum 179 days gap is allowed in relieving (from previous station) and joining (at new
              station) to cover all kinds of joining / vacation period.</li>
          </ul>
        </div>

        <div *ngIf="profile?.serviceBooks && profile.serviceBooks.length > 0" class="table-responsive">
          <table class="table align-items-center table-hover">
            <colgroup>
              <col style="width: 5%">
              <col style="width: 15%">
              <col style="width: 15%">
              <col style="width: 10%">
              <col style="width: 10%">
              <col style="width: 15%">
              <!-- <col style="width: 15%"> -->
              <col style="width: 15%">
            </colgroup>
            <thead class="table-light">
              <tr>
                <th *ngFor="let c of columns">
                  <div *ngIf="c.isSortable">
                    <div class="d-flex justify-content-between align-items-center">
                      {{ c.title }}
                    </div>
                  </div>
                  <div *ngIf="!c.isSortable">
                    {{ c.title }}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let v of profile.serviceBooks | orderBy:'durationFrom' : true; let i=index;">
                <td>{{ i + 1 }}</td>
                <td>{{ v.school?.name }}</td>
                <td>{{ v.designation?.name }}</td>
                <td>{{ v.durationFrom | date }}</td>
                <td>
                  <span *ngIf="v.durationTo">{{ v.durationTo | date }}</span>
                  <span *ngIf="!v.durationTo">Present</span>
                </td>
                <td>
                  {{ v.transferReason?.name }}
                  <span *ngIf="v.appointmentMode">{{ '('+ v.appointmentMode?.name + ')' }}</span>
                </td>
                <!-- <td>{{ v.transferCategory?.name }}</td> -->
                <td>{{ v.leaveCount }}</td>
                <td>
                  <a *ngIf="!v.isPresent" class="btn btn-sm btn-icon-only"
                    [routerLink]="['/management/employees/service-book/edit', profileId, v.id,financialYearId]">
                    <i-bs name="pencil-square" width="1em" height="1em"></i-bs>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="profile?.serviceBooks && profile.serviceBooks.length <= 0" class="row">
          <div class="col-md-12 text-center">
            <h4 class="description text-default">Ooooups! Looks like you have not enter any service book details.</h4>
            <a class="btn btn-primary my-3" [routerLink]="['/management/employees/service-book/new', profileId,financialYearId]">Fill up
              Details</a>
          </div>
        </div>
        <div class="d-flex justify-content-end mb-3">
          <a [routerLink]="['/management/employees/service-book/new', profileId,financialYearId]" class="btn btn-success rounded-0">ADD</a>
        </div>
        <hr />
        <div class="d-flex justify-content-center mb-3">
          <a [routerLink]="['/management/employees/viewprofile', profileId,financialYearId]" class="btn btn-primary rounded-0">BACK TO VIEW</a>
        </div>
      </div>

    </div>
  </div>
</div>